import React from 'react';

import type { Seo } from '@sravni/types/lib/seo';

import type { Card } from '@src/@types/microcredits';

import { SeoSchema } from './SeoSchema';

interface Props {
  seo: Seo;
  path: string;
  microcredit: Card.IRes;
}

export const SeoMfoSchema = (props: Props) => <SeoSchema {...props} />;
